/*
**  @desc:    基础的统计方法
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/

var BaseStat = (function() {
    /*
     * @private
     */
    function appendParams(params) {
        var paramsArray = [];
        params._time_ = (+new Date()) + Math.random().toString().substring(2, 15);
        for(var i in params) {
            if (params.hasOwnProperty(i)) {
                paramsArray.push(i + '=' + params[i]);
            }
        }
        return paramsArray.join('&');
    }

    /**
    * @private
    * 验证请求链接的合法性
    */
    function isValidUrl(url){
        return /^http:\/\//.test(url) || /^https:\/\//.test(url) || /^\/\//.test(url);
    }

    /**
    * 发送一个简单的统计请求
    * @public
    * @param {String} base (optional) 统计请求文件地址
    * @param {String} params 统计参数
    **/
    function sendStatistics(base, params) {
        var image;

        if (base && isValidUrl(base)) {
            if (base.slice(base.length - 1) !== '?') {
                base = base + '?';
            }

            image = new Image(1, 1);
            image.src = base + appendParams(params);
        }
    }

    return {
        sendStatistics: sendStatistics
    }

})();

module.exports = BaseStat;


// WEBPACK FOOTER //
// ./src/statistics/base-stat.js